/* Nutraviva lander behaviour: scroll reveals, count-up figures, scroll progress.
   Buy-box logic lives in sections/nv-buy-box.liquid (needs Liquid-rendered variant data).
   Everything here is progressive enhancement: with JS off the page is fully readable. */
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Scroll progress ---------------------------------------------------- */
  var bar = document.querySelector('[data-nv-progress]');
  if (bar && !reduced) {
    var onScroll = function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (h > 0 ? Math.min(100, (window.scrollY / h) * 100) : 0) + '%';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Reveals ------------------------------------------------------------ */
  var HIDDEN = { up: 'nv-hidden-up', row: 'nv-hidden-row', clip: 'nv-hidden-clip' };

  function initReveals(root) {
    if (reduced) return;
    var els = (root || document).querySelectorAll('[data-nv-reveal]:not([data-nv-armed])');
    if (!els.length || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        show(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px' });

    els.forEach(function (el) {
      el.setAttribute('data-nv-armed', '');
      var kind = el.getAttribute('data-nv-reveal') || 'up';
      var order = parseInt(el.getAttribute('data-nv-order') || '1', 10);
      var dur = kind === 'clip' ? 760 : 620;
      var delay = (order - 1) * 80;
      el.style.transition = ['opacity', 'transform', 'clip-path'].map(function (p) {
        return p + ' ' + dur + 'ms var(--nv-ease) ' + delay + 'ms';
      }).join(', ');
      /* Already in view on load: leave it painted, no flash. */
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) return;
      el.classList.add(HIDDEN[kind] || HIDDEN.up);
      io.observe(el);
    });

    function show(el) {
      el.classList.remove(HIDDEN.up, HIDDEN.row, HIDDEN.clip);
      el.classList.add('nv-shown');
    }
  }

  /* Count-up figures --------------------------------------------------- */
  function initCounters(root) {
    if (reduced || !('IntersectionObserver' in window)) return;
    var els = (root || document).querySelectorAll('[data-nv-count]:not([data-nv-counted])');
    if (!els.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        run(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.6 });

    els.forEach(function (el) { io.observe(el); });

    function run(el) {
      el.setAttribute('data-nv-counted', '');
      var target = parseFloat(el.getAttribute('data-nv-count'));
      var decimals = (el.getAttribute('data-nv-count').split('.')[1] || '').length;
      var prefix = el.getAttribute('data-nv-prefix') || '';
      var suffix = el.getAttribute('data-nv-suffix') || '';
      var start = performance.now();
      var dur = 900;
      (function step(t) {
        var p = Math.min(1, (t - start) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
        if (p < 1) requestAnimationFrame(step);
      })(start);
    }
  }

  /* Accordions --------------------------------------------------------- */
  function initAccordions(root) {
    (root || document).querySelectorAll('[data-nv-accordion]:not([data-nv-bound])').forEach(function (acc) {
      acc.setAttribute('data-nv-bound', '');
      acc.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-nv-accordion-trigger]');
        if (!trigger) return;
        var item = trigger.closest('[data-nv-accordion-item]');
        var open = item.getAttribute('data-open') === 'true';
        if (acc.getAttribute('data-nv-accordion') === 'single') {
          acc.querySelectorAll('[data-nv-accordion-item]').forEach(function (i) {
            i.setAttribute('data-open', 'false');
            i.querySelector('[data-nv-accordion-trigger]').setAttribute('aria-expanded', 'false');
          });
        }
        item.setAttribute('data-open', open ? 'false' : 'true');
        trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  function boot(root) {
    initReveals(root);
    initCounters(root);
    initAccordions(root);
  }

  document.addEventListener('DOMContentLoaded', function () { boot(document); });
  if (document.readyState !== 'loading') boot(document);

  /* Theme editor: re-arm when a section is re-rendered. */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
